import React, { useState, useEffect, useCallback } from "react";
import { producaov2 as api } from "../../../../../services/apis";
import {
  Icon,
  Header,
  Button,
  Modal,
  Divider,
  Dropdown,
} from "semantic-ui-react";
import ReactHtmlParser from "react-html-parser";
import {
  Container,
  Content,
  Title,
  DivTutor,
  DivModulo,
  DivTutores,
  Input,
  Label,
} from "./styles";
import swal from "sweetalert";
import { Link } from "react-router-dom";
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";
import { isAuthAdmin } from "../../../../../services/auth";

const EditarCursos = (props) => {
  const id = props.match.params.id;
  const [tutores, setTutores] = useState([]);
  const [modulos, setModulos] = useState([]);
  const [addTutores, setAddTutores] = useState([]);
  const [tutorOpen, setTutorOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [addOpen, setAddOpen] = useState(false);
  const [newTutor, setNewTutor] = useState({});
  const [addModulo, setAddModulo] = useState({
    titulo: "",
    ordem: 0,
    duracao: "",
  });
  const [modalOption, setModalOption] = useState({
    titulo: "",
    ordem: "",
    duracao: "",
    index: "",
    id: "",
  });
  const [moduleAndOrder, setModuleAndOrder] = useState(modulos.map((modulo) => ({
    id: modulo.id,
    ordem: modulo.ordem,
  })));

  useEffect(() => {
    loadAuth();
    loadTutores();
    loadModulo();
  }, []);

  useEffect(() => {
  setModuleAndOrder(
    modulos.map((modulo) => ({
      id: modulo.id,
      ordem: modulo.ordem,
    }))
  );
}, [modulos]);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const loadTutores = () => {
    api
      .get(`/tutores/curso/${id}`)
      .then((res) => {
        setTutores([...tutores, ...res.data]);
      })
      .catch((err) => {
        swal("Não foi possível carregar os tutores", err, "");
      });
  };

  const loadModulo = () => {
    api
      .get(`/online/modulos/${id}`)
      .then(async (res) => {
        let logs = { local: "cursos", texto: `listou o curso de id=${id}` };
        api.post("system_logs", { acao: JSON.stringify(logs) });

        const newModulos = res.data;

        newModulos.sort((a, b) => a.ordem - b.ordem);

        setModulos(newModulos);
      })
      .catch((err) => {
        swal("Não foi possível carregar os modulos", err, "");
      });
  };

  const loadNewTutores = (search) => {
    api
      .get(`alunos?search=${search}&page=1&limit=10`)
      .then((res) => {
        if (res.data.length == 0) {
        } else {
          const valor = res.data.map((tutor) => ({
            key: tutor.id,
            value: tutor.id,
            text: `${tutor.id} - ${tutor.nome} - ${tutor.email}`,
            email: tutor.email,
          }));
          setAddTutores([...valor]);
        }
      })
      .catch((err) => {
        swal("Não foi possível carregar os tutores", err, "");
      });
  };
  const removeTutor = useCallback(
    (id) => {
      swal("Tem certeza que quer deletar esse tutor", "", "").then((res) => {
        api
          .delete(`/tutores/${id}`)
          .then(() => {
            const newTutores = [...tutores].filter((tutor) => tutor.id !== id);
            setTutores(newTutores);
            swal("tutor deletado com sucesso", "", "success");
          })
          .catch((err) => {
            swal("Não foi possível deletar o tutor", err, "");
          });
      });
    },
    [tutores]
  );

  const removeModulo = useCallback(
    (id) => {
      swal({
        title: "Excluir",
        text: `Tem certeza que quer deletar esse modulo?`,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          api
            .delete(`admin/modulos/${id}`)
            .then(() => {
              const newModulos = [...modulos].filter(
                (modulo) => modulo.id !== id
              );
              setModulos(newModulos);
              swal("modulo deletada com sucesso", "", "success");
            })
            .catch((err) => {
              swal("Não foi possível deletar o modulo", err, "");
            });
        }
      });
    },
    [modulos]
  );

  const modifyTitle = useCallback(async () => {
    const payload = {
      titulo: modalOption.titulo,
      ordem: modalOption.ordem.toString(),
      duracao: modalOption.duracao,
    };

    await api
      .put(`/admin/modulos/${modalOption.id}`, payload)
      .then(async () => {
        let logs = {
          local: "cursos",
          texto: `editou o curso de id=${modalOption.id}`,
        };
        api.post("system_logs", { acao: JSON.stringify(logs) });
        const newModulos = modulos;
        newModulos[modalOption.index]["titulo"] = modalOption.titulo;
        setModulos([...newModulos]);
        swal("modulo modificado com sucesso", "", "success");
      })
      .catch((err) => {
        swal("Não foi possível modificar o modulo", err, "");
      });
  }, [modulos, modalOption]);

  const addModulos = useCallback(async () => {
    const payload = {
      id_curso: id,
      titulo: addModulo.titulo,
      ordem: addModulo.ordem,
      duracao: addModulo.duracao,
      licoes: [],
    };

    await api
      .post(`admin/modulos/curso/`, payload)
      .then((res) => {
        setModulos((prev) => [
          ...(Array.isArray(prev) ? prev : []),
          { ...res.data.creationReturn, licoes: [] },
        ]);

        setAddModulo({
          titulo: "",
          ordem: 0,
          duracao: "",
        });

        swal("modulo criado com sucesso", "", "success");
        let logs = { local: "cursos", texto: `criou ` };
        api.post("system_logs", { acao: JSON.stringify(logs) });
      })
      .catch((err) => {
        swal("Não foi possível criar o modulo", err, "");
      });
  }, [addModulo]);

  const createTutor = useCallback(async () => {
    const payload = {
      id_curso: id,
      id_pessoa: newTutor.value,
    };

    await api
      .post(`/tutores/curso/`, payload)
      .then(() => {
        setTutores([
          ...tutores,
          { id: newTutor.value, pessoa: { nome: newTutor.text } },
        ]);
        swal("Tutor criado com sucesso", "", "success");
      })
      .catch((err) => {
        swal("Não foi possível criar o tutor", err, "");
      });
  }, [tutores, newTutor]);

  const tutoresAdd = useCallback(
    (id) => {
      const newTutores = [...addTutores].filter((tutor) => tutor.key === id);
      setNewTutor(...newTutores);
    },
    [newTutor, addTutores]
  );

  const moveModuloUp = (index) => {
    if (index === 0) return;
    setModuleAndOrder((prev) => {
      const newOrder = [...prev];
      [newOrder[index - 1], newOrder[index]] = [newOrder[index], newOrder[index - 1]];
      return newOrder.map((mod, idx) => ({ ...mod, ordem: idx }));
    });
  };

  const moveModuloDown = (index) => {
    if (index === moduleAndOrder.length - 1) return;
    setModuleAndOrder((prev) => {
      const newOrder = [...prev];
      [newOrder[index], newOrder[index + 1]] = [newOrder[index + 1], newOrder[index]];
      return newOrder.map((mod, idx) => ({ ...mod, ordem: idx }));
    });
  };

  const handleEditOrder = async () => {
    try {
      await api.put(`/admin/ordem`, moduleAndOrder);
      swal("Ordem dos módulos atualizada com sucesso!", "", "success");
      loadModulo(); 
    } catch (err) {
      swal("Erro ao atualizar ordem dos módulos", err, "");
    }
  };

  const isOrderChanged = () => {
    if (modulos.length !== moduleAndOrder.length) return false;
    return modulos.some((mod, idx) => mod.id !== moduleAndOrder[idx].id);
  };

  useEffect(() => {
    if (Array.isArray(modulos) && addModulo?.ordem !== modalOption) {
      setAddModulo((prev) => ({ ...prev, ordem: modulos.length + 1 }));
    }
  }, [modulos]);

  return (
    <>
      <Container>
        <AdminMenu />

        <Content>
          <Title>Cursos</Title>

          <div>
            <h3>Editar curso: #{id}</h3>
            <label>Tutores:</label>
            <DivTutores>
              {tutores == null
                ? "Não tem tutores"
                : tutores.map((tutor) => (
                    <DivTutor>
                      <label>{tutor.pessoa?.nome}</label>
                      <Button
                        icon
                        color="red"
                        floated="right"
                        onClick={() => removeTutor(tutor.id)}
                      >
                        <Icon name="remove" color="white" />
                      </Button>
                    </DivTutor>
                  ))}
              <DivTutor>
                <Button
                  icon
                  color="green"
                  fluid
                  floated="right"
                  onClick={() => setTutorOpen(true)}
                >
                  <Icon name="plus" />
                  Adicionar tutor
                </Button>
              </DivTutor>
            </DivTutores>
          </div>

          <div>
            <h3>Modulos</h3>
            <Button icon color="green" onClick={() => setAddOpen(true)}>
              <Icon name="plus" />
              Adicionar Modulos
            </Button>
            <Button icon color="green" onClick={handleEditOrder} disabled={!isOrderChanged()}>
              <Icon name="edit" />
              Salvar edição da ordem
            </Button>
            <div>
              {moduleAndOrder.length === 0
                ? "Não tem modulos"
                : moduleAndOrder.map((orderItem, index) => {
                    const modulo = modulos.find((m) => m.id === orderItem.id);
                    if (!modulo) return null;
                    return (
                      <DivModulo key={modulo.id}>
                        <Button 
                        icon onClick={() => moveModuloUp(index)} 
                        disabled={index === 0} 
                        size="mini"
                        color="grey"
                        style={{ marginRight: 4, opacity: index === 0 ? 0.4 : 1 }}>
                          <Icon name="arrow up" />
                        </Button>
                        <Button 
                        icon onClick={() => moveModuloDown(index)} 
                        disabled={index === moduleAndOrder.length - 1} 
                        size="mini"
                        color="grey"
                        style={{ opacity: index === moduleAndOrder.length - 1 ? 0.4 : 1 }}>
                          <Icon name="arrow down" />
                        </Button>
                        <Label>Titulo: </Label>
                        {ReactHtmlParser(modulo.titulo)} - <Label>Lições: </Label>
                        {modulo.licoes.length}
                        <Button
                          floated="right"
                          icon
                          color="grey"
                          onClick={() => {
                            setOpen(true);
                            setModalOption({
                              ...modalOption,
                              titulo: modulo.titulo,
                              index: index,
                              id: modulo.id,
                              ordem: modulo.ordem,
                              duracao: modulo.duracao,
                            });
                          }}
                        >
                          <Icon name="edit" />
                          Nome do modulo
                        </Button>
                        <Link
                          target="_blank"
                          to={`/admin/ead/cursos/${id}/modulos/${modulo.id}/licoes`}
                        >
                          <Button floated="right" icon color="yellow">
                            <Icon name="edit" />
                            lições do modulo
                          </Button>
                        </Link>
                        <Button
                          floated="right"
                          icon
                          color="red"
                          onClick={() => removeModulo(modulo.id)}
                        >
                          <Icon name="remove" color="white" />
                        </Button>
                        <Divider />
                      </DivModulo>
                    );
                  })}
            </div>
          </div>
        </Content>
      </Container>

      <Modal
        closeIcon
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
      >
        <Header icon="edit" content="Editar modulo" />
        <Modal.Content>
          <label>Nome:</label>
          <Input
            type="text"
            value={modalOption.titulo}
            onChange={(e) =>
              setModalOption({ ...modalOption, titulo: e.target.value })
            }
          />
          <label>Duração:</label>
          <Input
            type="text"
            value={modalOption.duracao}
            placeholder="1h 0m"
            onChange={(e) =>
              setModalOption({ ...modalOption, duracao: e.target.value })
            }
          />
        </Modal.Content>
        <Modal.Actions>
          <Button color="red" onClick={() => setOpen(false)}>
            <Icon name="remove" /> No
          </Button>
          <Button
            color="green"
            onClick={() => {
              modifyTitle();
              setOpen(false);
            }}
          >
            <Icon name="checkmark" /> Yes
          </Button>
        </Modal.Actions>
      </Modal>

      <Modal
        closeIcon
        open={addOpen}
        onClose={() => setAddOpen(false)}
        onOpen={() => setAddOpen(true)}
      >
        <Header icon="edit" content="Criar modulo" />
        <Modal.Content>
          <label>Nome:</label>
          <Input
            type="text"
            value={addModulo.titulo}
            onChange={(e) =>
              setAddModulo({ ...addModulo, titulo: e.target.value })
            }
          />
          <label>Ordem:</label>
          <Input
            type="text"
            value={addModulo.ordem}
            onChange={(e) =>
              setAddModulo({ ...addModulo, ordem: e.target.value })
            }
          />
          <label>Duração:</label>
          <Input
            type="text"
            value={addModulo.duracao}
            placeholder="1h 0m"
            onChange={(e) =>
              setAddModulo({ ...addModulo, duracao: e.target.value })
            }
          />
        </Modal.Content>
        <Modal.Actions>
          <Button color="red" onClick={() => setAddOpen(false)}>
            <Icon name="remove" /> No
          </Button>
          <Button
            color="green"
            onClick={() => {
              addModulos();
              setAddOpen(false);
            }}
          >
            <Icon name="checkmark" /> Yes
          </Button>
        </Modal.Actions>
      </Modal>

      <Modal
        closeIcon
        open={tutorOpen}
        onClose={() => setTutorOpen(false)}
        onOpen={() => setTutorOpen(true)}
      >
        <Header icon="edit" content="Criar Tutor" />
        <Modal.Content>
          <label>Nome:</label>
          <Dropdown
            placeholder="Tutores..."
            fluid
            search
            onSearchChange={(e) => loadNewTutores(e.target.value)}
            selection
            options={addTutores}
            onChange={(e, data) => {
              tutoresAdd(data.value);
            }}
          />
          <Divider />
          <label>ID:{newTutor.key}</label>
          <Divider />
          <label>Nome:{newTutor.text}</label>
          <Divider />
          <label>Email:{newTutor.email}</label>
        </Modal.Content>
        <Modal.Actions>
          <Button color="red" onClick={() => setTutorOpen(false)}>
            <Icon name="remove" /> No
          </Button>
          <Button
            color="green"
            onClick={() => {
              createTutor();
              setTutorOpen(false);
            }}
          >
            <Icon name="checkmark" /> Yes
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default EditarCursos;
